// Product pictures use a 2:3 ratio: the height is 1.5 times the width.
const PRODUCT_PICTURE_HEIGHT_FACTOR = 3 / 2;

const getBasePicturePath = (src) => {
  const imagePath = src.match(/(upload.*)/)[0];
  let basePath = imagePath.replace("standard_", "large_");
  basePath = basePath.replace("thumb_", "large_");

  return basePath;
};

const ImgixLoader = ({ src, width }) => {
  // https://lecloset.imgix.net/uploads/picture/image/prd_4R3Yur/standard_IMG_7385.jpg?w=200&h=300&fit=crop&q=80&auto=format
  const apiEndPoint = "https://lecloset.imgix.net";
  const imagesPath = src.match(/(upload.*)/);
  if (!imagesPath) return "";

  const basePath = getBasePicturePath(src);
  // We crop the source to keep the 2:3 ratio.
  const height = Math.round(width * PRODUCT_PICTURE_HEIGHT_FACTOR);
  const transform = `w=${width}&h=${height}&fit=crop&q=75&auto=format`;
  const transformedImageUrl = `${apiEndPoint}/${basePath}?${transform}`;
  return transformedImageUrl;
};

export default ImgixLoader;
